module.exports = __webpack_public_path__ + "static/img/sign_rfrc.6f7d4bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/sign_rfrc.svg
// module id = mf3W
// module chunks = 1